import BaseVehicle from "./baseVehicle.js";

export default class Bus extends BaseVehicle {
  constructor(parent, assetName, speed, zIndex) {
    super(parent, assetName, speed, zIndex);
  }
}